const getFacebookScopePermissions = () => {
  const fbMessengerPermissions = [
    'email',
    'pages_messaging',
    'pages_show_list',
    'public_profile',
    'pages_manage_metadata',
    'pages_read_engagement',
    'business_management'
  ];
  const instagramPermissions = [
    'instagram_basic',
    'instagram_manage_messages',
  ];
  return [...fbMessengerPermissions, ...instagramPermissions].join();
};

export { getFacebookScopePermissions };
